export const TH_LIST_METRICS = [
    { Name: 'TEMPERATURE', Value: 'temperature' },
    { Name: 'SETPOINT', Value: 'setpoint' },
    { Name: 'HUMIDITY', Value: 'humidity' },
    { Name: 'EXT_TEMPERATURE', Value: 'ext_temperature' },
    { Name: 'EXT_HUMIDITY', Value: 'ext_humidity' },
    { Name: 'RELAY_STATUS', Value: 'relay_status' },
];

export class LogThExport {
    Url?: string;
    FileType?: string;

    constructor() {
        this.Url = '';
        this.FileType = '';
    }
}